import { FilterConditions, INSERT, SELECT, UPDATE , execute} from "@/utils/database_module"
import { logDebug } from "@/utils/helpers";
import { Section , Product } from "@/utils/types"
import { log } from "console";

const sections = {
    getAll : async (is_admin : boolean ,) => {

        // * Best sellers section
        let bestSellersQuery = `SELECT  products.id , COUNT(orders.product_id) AS data 
                                FROM products JOIN orders ON products.id = orders.product_id 
                                WHERE products.is_deleted = 0 AND is_public = 1 GROUP BY orders.product_id ORDER BY data DESC LIMIT 10`;
        const bestSellers = (await execute(bestSellersQuery)) as Product[];
        const bestSellersIds = bestSellers.map((product) => product.id);
        await UPDATE("sections", { items: JSON.stringify(bestSellersIds) }, [ { column: "id", operator: "=", value: 1 }, ]);
    
        // * New products section
        const newProducts = (await execute( "SELECT id , date FROM products WHERE products.is_deleted = 0 AND is_public =1 ORDER BY date DESC LIMIT 10" )) as Product[];
        const newProductsIds = newProducts.map((product) => product.id);
        await UPDATE("sections", { items: JSON.stringify(newProductsIds) }, [ { column: "id", operator: "=", value: 2 }, ]);
    
        const conditions = [ { column: "is_deleted", operator: "=", value: "0", },{ column: "is_cars", operator: "=", value: 0, } ] as FilterConditions;
        if (!is_admin)  conditions!.push({ column: "is_active", operator: "=", value: "1", });
    
        const sections = (await SELECT(`sections`, { order: "display_order ", conditions: conditions, })) as Section[];

        const products = (await SELECT(`products`, {})) as Product[];

        for (let i = 0; i < sections.length; i++) {
            sections[i].items =JSON.parse(`${sections[i].items}`) ?? [];
            for ( let k = 0; k < sections[i].items?.length; k++) {
                const selectedProduct = products.find((p)=> p?.id == sections[i].items[k]) as Product;
                if(!selectedProduct) break
                selectedProduct.image = selectedProduct?.images? JSON.parse(`${selectedProduct?.images}`)[0] : "";
                sections[i].items[k]= selectedProduct;
            }
            
        }
      
        return sections
    },
   

    insert : async (section : Section) => {
        return await INSERT("sections" , {...section , is_cars :0})
    },

    update : async (id : number , section : Partial<Section>) => {
        return await UPDATE("sections" , section , [{column : "id" , operator : "=" , value : id}])
     
    },

    delete : async (id : number) => {
        return await UPDATE("sections" , { is_deleted : 1 } , [{column : "id" , operator : "=" , value : id}])
    },

}   

export default sections